import FieldMappingGroup from '../FieldMappingGroup';
import FieldMappingRow from '../FieldMappingRow';

const FieldMappingFormFields = ({
  fieldErrors,
  sortedMappings,
  handleMappingChange,
  applyChangesToAllGroupMembers,
  removeMappingGroup,
  removeMapping,
  addMapping,
  objectType,
  sourceAttributes,
  targetAttributes,
  integration,
  showInvalidFields,
  onClickRefreshAttributes,
  hasEnrichmentBetaUIFlag,
}) => {
  return (
    <div className="space-y-6">
      {sortedMappings.map((mapping) => {
        if (mapping.groupId) {
          return (
            <FieldMappingGroup
              key={`group:${mapping.groupId}`}
              group={mapping}
              type={integration}
              objectType={objectType}
              onChange={handleMappingChange}
              onGroupChange={applyChangesToAllGroupMembers(mapping.groupId)}
              onRemove={removeMappingGroup(mapping.groupId)}
              onRemoveMapping={removeMapping}
              sourceAttributes={sourceAttributes || []}
              targetAttributes={targetAttributes || []}
              addMapping={addMapping}
              showError={showInvalidFields}
              errors={fieldErrors}
            />
          );
        }

        return (
          <FieldMappingRow
            index={mapping.index}
            key={`${mapping.targetField || 'empty'}
          :${mapping.sourceField || 'empty'}
          -${mapping.index}`}
            mapping={mapping}
            type={integration}
            objectType={objectType}
            onChange={handleMappingChange(mapping.index)}
            onClickRefreshAttributes={onClickRefreshAttributes}
            onRemove={removeMapping(mapping.index)}
            sourceAttributes={sourceAttributes || []}
            targetAttributes={targetAttributes || []}
            hasEnrichmentBetaUIFlag={hasEnrichmentBetaUIFlag}
            sourceErrors={fieldErrors[mapping.sourceField]}
            targetErrors={fieldErrors[mapping.targetField]}
            showError={showInvalidFields}
          />
        );
      })}
    </div>
  );
};

export default FieldMappingFormFields;
